// Retired links land on the remaining Marketing workspace, not a posting UI.
export const SOCIAL_POSTING_URL = "/website?tab=library";

/** Forward old social links before Messaging can consume their entry params. */
export function legacySocialPostingDestination(search: string, hash = ""): string | null {
  const params = new URLSearchParams(search);
  const top = params.get("top");
  // Messaging has always given either legacy Stats selector precedence.
  if (top === "stats" || params.get("tab") === "stats") return null;
  if (top !== "social" && (top !== null || params.get("tab") !== "social")) return null;
  params.delete("top");
  params.set("tab", "library");
  return `/website?${params.toString()}${hash}`;
}